import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Croissant } from "lucide-react";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";

const ownerRoles = ["super_admin", "admin", "manager"];

export default function MobileLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("delivery@bakemill.com");
  const [password, setPassword] = useState("Delivery@2026");
  const [busy, setBusy] = useState(false);

  if (user) {
    const target = ownerRoles.includes(user.role) || !user.branch_id ? "/m/owner" : "/m/home";
    return <Navigate to={target} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      const target = ownerRoles.includes(u?.role) || !u?.branch_id ? "/m/owner" : "/m/home";
      nav(target);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col justify-between bg-[#2C1810] text-[#FDFBF7] max-w-md mx-auto p-6"
      data-testid="m-login-page"
    >
      <div className="pt-10 flex flex-col items-center text-center gap-4">
        <div className="w-14 h-14 rounded-lg bg-[#C05621] flex items-center justify-center">
          <Croissant className="w-7 h-7" />
        </div>
        <div>
          <h1 className="font-[Outfit] text-3xl font-semibold tracking-tight">Bakemill Field</h1>
          <p className="text-sm text-[#C8B8A0] mt-1">Staff on-field portal · GPS check-in & deliveries</p>
        </div>
      </div>

      <form onSubmit={submit} className="space-y-3 mb-10">
        <div>
          <label className="text-[11px] uppercase tracking-widest text-[#C8B8A0]">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="m-login-email"
            className="w-full mt-1 h-12 rounded-md bg-[#3a2418] border border-[#5C4033] px-3 text-[#FDFBF7] placeholder:text-[#8B7355] focus:border-[#C05621] outline-none"
          />
        </div>
        <div>
          <label className="text-[11px] uppercase tracking-widest text-[#C8B8A0]">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="m-login-password"
            className="w-full mt-1 h-12 rounded-md bg-[#3a2418] border border-[#5C4033] px-3 text-[#FDFBF7] placeholder:text-[#8B7355] focus:border-[#C05621] outline-none"
          />
        </div>
        <button
          type="submit"
          disabled={busy}
          data-testid="m-login-submit"
          className="w-full h-12 rounded-md bg-[#C05621] hover:bg-[#9C4221] text-white font-semibold uppercase tracking-widest text-sm disabled:opacity-50"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <p className="text-[11px] text-center text-[#C8B8A0]">
          Demo: delivery@bakemill.com / Delivery@2026
        </p>
      </form>
      <Toaster position="top-center" richColors />
    </div>
  );
}
